import React, { useEffect, useState } from "react";
import { Typography, Box, Paper, CircularProgress } from "@mui/material";
import { useIntl } from "react-intl";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import { useAuth } from "../providers/AuthProvider";
import { fetchCompany } from "../api/companyApi";

export default function HomePage() {
  const intl = useIntl();
  const { companyId } = useAuth();
  const t = (id) => intl.formatMessage({ id });

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    fetchCompany(companyId)
      .then((data) => setCompany(data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [companyId]);

  return (
    <Paper elevation={0} sx={{ p: 4, textAlign: "center", mt: 4 }}>
      <VolunteerActivismIcon sx={{ fontSize: 64, color: "primary.main", mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        {t("home.welcome")}
      </Typography>

      {loading ? (
        <CircularProgress size={24} sx={{ mt: 2 }} />
      ) : company?.purpose ? (
        <Paper variant="outlined" sx={{ p: 3, mt: 3, textAlign: "left" }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            {t("companyValues.title")}
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", lineHeight: 1.8 }}>
            {company.purpose}
          </Typography>
        </Paper>
      ) : (
        <Typography color="text.secondary" sx={{ mt: 2 }}>
          {t("companyValues.empty")}
        </Typography>
      )}
    </Paper>
  );
}
